/**
 * ADR-0210 Slice 1/2 — agent rollups API (the read side of the daily
 * rollups). Wire shape mirrors `services/api/src/http/routes/v1/
 * sites-agent-rollups.ts`. Everything here is DERIVED, unsigned data:
 * `derived: true` rides on the response so no renderer can mistake it
 * for a signed record.
 */
export const DISCOVERY_KINDS = [
    'agent_card',
    'proof',
    'ucp',
    'mcp_card',
    'api_catalog',
    'ai_catalog',
    'llms_txt',
    'agent_page',
    'well_known',
];
/**
 * Human-readable label for a discovery-kind id — the merchant-facing
 * caption rendered in the readiness Journey "Find" drawer and the
 * dashboard's Agents detail view.
 */
export function discoveryKindLabel(kind) {
    const direct = {
        agent_card: 'agent card',
        proof: 'proof token',
        ucp: 'UCP profile',
        mcp_card: 'MCP card',
        api_catalog: 'API catalog',
        ai_catalog: 'AI catalog',
        llms_txt: 'llms.txt',
        agent_page: 'agent page',
        well_known: 'other agent files (keys, manifests, ai.txt)',
    };
    return direct[kind] ?? kind.replace(/_/g, ' ');
}
//# sourceMappingURL=agent-rollups-api.js.map